import * as Yup from "yup";

export const DepartmentPermissionFormValidation = Yup.object({
    employeeId: Yup.string()
        .required("Employee is required"),
    permissionTypeName: Yup.string()
        .required("Permission is required"),
});
